const SHEET_URL =
  "https://docs.google.com/spreadsheets/d/1-B3reA5h2nkQOg3RlrHXhtrnJ_TNfzdhQOt26llfi8I/export?format=csv";

function getLocalYYYYMMDD() {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  
  return `${year}-${month}-${day}`;
}

function parseCSV(text) {
  // Remove \r to ensure line-endings don't break string equality checks
  const cleanText = text.replace(/\r/g, "");
  const rows = cleanText.split("\n").map(r => r.split(","));

  // Uses local device time (Midnight in user's timezone)
  const today = getLocalYYYYMMDD();

  const todayRow = rows.find(row => row[0]?.trim() === today);

  if (!todayRow) return null;

  return {
    name: todayRow[1]?.trim(),
    country: todayRow[2]?.trim(),

    // NEW FIELDS (from your sheet)
    departure: todayRow[8]?.trim(),   // Column I
    flightTime: todayRow[9]?.trim(),  // Column J

    clues: todayRow.slice(3, 8).map(c => c?.trim()).filter(Boolean)
  };
}

export default async function getDailyCity() {
  // Prevent Google Sheets CSV export caching
  const cacheBusterUrl = `${SHEET_URL}&t=${Date.now()}`;

  const res = await fetch(cacheBusterUrl, { cache: "no-store" });
  const text = await res.text();

  return parseCSV(text);
}